import * as cl from "classnames"
import * as React from "react"

export default class ServerPortField extends React.Component<Props> {
	static id = "local-authority-detail-bl-server-port"

	render() {
		const className = cl("input is-fullwidth", { "is-loading": this.props.loading })

		return <div className="field">
		<label className="label" htmlFor={ServerPortField.id}>
			Port du serveur
		</label>

		<span className="control">
			<input
			className={className}
			disabled={this.props.loading}
			id={ServerPortField.id}
			placeholder="54452"
			required
			type="number"
			value={this.props.value || ""}
			onChange={e => this.handleChange(e)}/>
		</span>
	</div>
	}

	private handleChange(e: React.ChangeEvent<HTMLInputElement>): void {
		const value = e.target.valueAsNumber !== NaN ? e.target.valueAsNumber : null
		this.props.onChange(value)
	}
}

interface Props {
	loading: boolean;
	value: number;
	onChange(value: number | null): void;
}



// WEBPACK FOOTER //
// ./src/component/page/local-authority-detail-page/connector-field/berger-levrault-connector/server-port-field.tsx